import React from "react";

function Thankyou_header(){

    return(
        <div className="thankyou-header">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h1>رسید پرداخت</h1>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Thankyou_header;